/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetCharactersCharacterIdContractsContractIdBidsNotFound
 */
export interface GetCharactersCharacterIdContractsContractIdBidsNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetCharactersCharacterIdContractsContractIdBidsNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdContractsContractIdBidsNotFound interface.
 */
export function instanceOfGetCharactersCharacterIdContractsContractIdBidsNotFound(value: object): value is GetCharactersCharacterIdContractsContractIdBidsNotFound {
    return true;
}

export function GetCharactersCharacterIdContractsContractIdBidsNotFoundFromJSON(json: any): GetCharactersCharacterIdContractsContractIdBidsNotFound {
    return GetCharactersCharacterIdContractsContractIdBidsNotFoundFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdContractsContractIdBidsNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdContractsContractIdBidsNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetCharactersCharacterIdContractsContractIdBidsNotFoundToJSON(json: any): GetCharactersCharacterIdContractsContractIdBidsNotFound {
    return GetCharactersCharacterIdContractsContractIdBidsNotFoundToJSONTyped(json, false);
}

export function GetCharactersCharacterIdContractsContractIdBidsNotFoundToJSONTyped(value?: GetCharactersCharacterIdContractsContractIdBidsNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

